import {useEffect} from 'react';
import {Text} from "@chakra-ui/react";
import {CardView} from '../Helper/cardView';
import {LogJoinPage} from "../Helper/analytics";

export function JoinPage() {
    useEffect(LogJoinPage, []);

    return (
        <CardView>
            <Text
                fontSize="4xl"
                fontWeight="black"
                color="red"
            >
                Game Discontinued
            </Text>
            <Text
                fontSize="lg"
            >
                Mafia: The Game has been discontinued and is no longer available to play.
            </Text>
            <Text
                fontSize="lg"
            >
                Thank you to everyone who played and supported the game.
            </Text>
        </CardView>
    );
}